/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import { respGridUtil } from '@marriott/mi-headless-utils';
import '../../libs/aemComponents/ExperienceFragment';
import {
  EditableHTLWrapper,
  StaticWrapper,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  CardCarouselContainer,
  CardLayered,
  Text,
  CardHorizontalMini,
  BannerLayered,
  CardVertical,
  CardHorizontalFeature,
  VariableColumnContainer,
  BannerText,
  Footer,
} from '@marriott/mi-common-static-components';
import {
  RnBHeroBannerEditable,
  OutletDetailsEditable,
  SearchFormEditable,
  SearchResultsEditable,
  RnBErrorMessageEditable,
  CollageEditorialEditable,
  HomePageEditorialEditable,
  CondensedFeatureEditable,
  PromotionBannerEditable,
  BonvoyMemberBannerEditable,
  RecommendedMiniCardsEditable,
  HeroBannerEditable,
  CardCarouselContainerEditable,
  CardLayeredEditable,
  CardVerticalEditable,
  OffersDynamicEditable,
  OverviewSectionEditable,
  StaticArticlesEditable,
  FeaturedOutletsEditable,
  CampaignOffersCardContainerEditable,
  EarnPointsSectionEditable,
  RecommendedOutletsEditable,
  NavigationTabEditable,
  DualCardContainerEditable,
  GolfCourseLocationsEditable,
  GolfServicesEditable,
  GolfContactDetailsEditable,
  GolfEventSchedulerEditable,
  GolfBioCardsContainerEditable,
  RnBRichTextEditable,
  RnBFAQAccordionWrapperEditable,
  PropertyDetailsEditable,
  TabEditableComponent,
  RecommendationsContainerEditable,
} from '@marriott/mi-rnb-components';

export const AEM_REACT_MAPPING = {
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobannercarousel`]: RnBHeroBannerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/outletinfo`]: OutletDetailsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchform`]: SearchFormEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/rnberror`]: RnBErrorMessageEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchresults`]: SearchResultsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardcarouselcontainer`]: CardCarouselContainerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardlayered`]: CardLayeredEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardvertical`]: CardVerticalEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/dynamicoffers`]: OffersDynamicEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/editorialcollage`]: CollageEditorialEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/editorialfeature`]: HomePageEditorialEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/condensedfeature`]: CondensedFeatureEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/promotionalbanner`]: PromotionBannerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/bannerwithbutton`]: BonvoyMemberBannerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/recommendation`]: RecommendedMiniCardsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobanner`]: HeroBannerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/overview`]: OverviewSectionEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/articlecards`]: StaticArticlesEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/featuredoutlet`]: FeaturedOutletsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/offersCardContainer`]: CampaignOffersCardContainerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/earnpointsprogramdetails`]: EarnPointsSectionEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/recommendationscardcontainer`]: RecommendedOutletsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/termandcondition`]: RnBRichTextEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/rnbaccordionenhanced`]: RnBFAQAccordionWrapperEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/navigationtab`]: NavigationTabEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golf-container`]: DualCardContainerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golflocationscard`]: GolfCourseLocationsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golfservices`]: GolfServicesEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golfcontact`]: GolfContactDetailsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/eventschedulecomponent`]: GolfEventSchedulerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/biocardscomponent`]: GolfBioCardsContainerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/propertydetails`]: PropertyDetailsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/recommendationscontainer`]:
    RecommendationsContainerEditable,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/text`]: Text,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  ['mi-aem-common-spa/components/content/cardhorizontalfeature']: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/tabcontainer`]: TabEditableComponent,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: VariableColumnContainer,
  [`mi-aem-common-spa/components/content/bannertext`]: BannerText,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  ['mi-aem-homepage-spa/components/content/universal-footer']: Footer,
};
export const defineComponentMapping = (allowedComponents, pagePath, isAuthorMode) => {
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/outletinfo`)(
    props => <OutletDetailsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'OutletDetails',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchform`)(
    props => <SearchFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'SearchForm',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchresults`)(
    props => <SearchResultsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'SearchResults',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/rnberror`)(
    props => <RnBErrorMessageEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'ErrorMessage',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/rnbaccordionenhanced`)(
    props => (
      <RnBFAQAccordionWrapperEditable {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ),
    {
      emptyLabel: 'RnBFAQAccordionWrapper',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
    emptyLabel: 'StaticWrapper',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobannercarousel`)(
    props => <RnBHeroBannerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'OutletHeroBanner',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/editorialcollage`)(
    props => <CollageEditorialEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'editorialcollage',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/editorialfeature`)(
    props => <HomePageEditorialEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'editorialfeature',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/condensedfeature`)(
    props => <CondensedFeatureEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'CondensedFeature',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/promotionalbanner`)(
    props => <PromotionBannerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'promotionalbanner',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/recommendation`)(
    props => <RecommendedMiniCardsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'recommendation',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobanner`)(
    props => <HeroBannerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'herobanner',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/overview`)(
    props => <OverviewSectionEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'overview',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/articlecards`)(
    props => <StaticArticlesEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'articlecards',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/featuredoutlet`)(
    props => <FeaturedOutletsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'featuredoutlet',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/dynamicoffers`)(
    props => <OffersDynamicEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'dynamicoffers',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardcarouselcontainer`)(props => (
    <CardCarouselContainerEditable {...props} isAuthorMode={isAuthorMode} />
  ));

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardlayered`)(CardLayeredEditable);

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardvertical`)(CardVerticalEditable);

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/bannerwithbutton`)(
    props => <BonvoyMemberBannerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'bannerwithbutton',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/earnpointsprogramdetails`)(
    props => <EarnPointsSectionEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'earnpointsprogramdetails',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/recommendationscardcontainer`)(
    props => <RecommendedOutletsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'RecommendedOutlets',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/termandcondition`)(
    props => <RnBRichTextEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'RichText',
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/offersCardContainer`)(
    props => <CampaignOffersCardContainerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'offerscard',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/navigationtab`)(
    props => <NavigationTabEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'navigationtab',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golf-container`)(
    props => <DualCardContainerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'golfcontainer',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golflocationscard`)(
    props => <GolfCourseLocationsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'golflocationscard',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golfservices`)(
    props => <GolfServicesEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'golfservices',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golfcontact`)(
    props => <GolfContactDetailsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'golfcontact',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/eventschedulecomponent`)(
    props => <GolfEventSchedulerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'eventschedulecomponent',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/biocardscomponent`)(
    props => <GolfBioCardsContainerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'biocardscomponent',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/propertydetails`)(
    props => <PropertyDetailsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'propertydetails',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/recommendationscontainer`)(
    props => <RecommendationsContainerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'recommendationscontainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(
    props => <CardHorizontalMini {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'cardhorizontalmini',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(BannerLayered);

  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature);

  MapTo(`mi-aem-common-spa/components/content/tabcontainer`)(
    props => (
      <TabEditableComponent
        {...props}
        isAuthorMode={isAuthorMode}
        allowedComponents={allowedComponents}
        componentPath="mi-rnb-components"
      />
    ),
    {
      emptyLabel: 'TabContainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(
    props => <VariableColumnContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'variablecolumncontainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/bannertext`)(BannerText);

  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
    props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'NavigationContainerWrapper',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper, {
    emptyLabel: 'NavigationUtilityLinkWrapper',
    isEmpty: false,
  });
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper, {
    emptyLabel: 'NavigationWrapper',
    isEmpty: false,
  });

  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered);

  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props => (
    <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));

  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);

  MapTo(`mi-aem-common-spa/components/content/text`)(props => <Text {...props} isAuthorMode={isAuthorMode} />, {
    emptyLabel: 'text',
    isEmpty: false,
  });

  MapTo('mi-aem-homepage-spa/components/content/universal-footer')(Footer, {
    emptyLabel: 'Footer',
    isEmpty: false,
  });

  const ExperienceFragmentVariationConfig = {
    emptyLabel: 'Experience Fragment',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };

  MapTo('mi-aem-common-spa/components/experiencefragment')(props => {
    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
      />
    );
  }, ExperienceFragmentVariationConfig);

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      }
    });
  }
};
